import { render, staticRenderFns } from "./RootUserHeader.vue?vue&type=template&id=329382dc&scoped=true"
import script from "./RootUserHeader.vue?vue&type=script&lang=js"
export * from "./RootUserHeader.vue?vue&type=script&lang=js"
import style0 from "./RootUserHeader.vue?vue&type=style&index=0&id=329382dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329382dc",
  null
  
)

export default component.exports